import { render } from "./DataTile.vue?vue&type=template&id=34633759&scoped=true"
import script from "./DataTile.vue?vue&type=script&lang=js"
export * from "./DataTile.vue?vue&type=script&lang=js"

import "./DataTile.vue?vue&type=style&index=0&id=34633759&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Documents\\eChook\\Code\\gpt-nano-configurator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34633759"]])

export default __exports__